import React, { useEffect, useRef, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import performanceManagementService from "@services/performanceManagement.service";
import strftime from "strftime";
import { Panel } from "primereact/panel";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/export-data")(Highcharts);

export default function Chart(data) {
  //   console.log("asdas", data);
  const chartRef = useRef(null);
  const [header, setHeader] = useState("");
  const options = {
    exporting: {
      enabled: true,
      width: 1920,
    },
    title: {
      text: "",
      align: "left",
    },
    chart: {
      zoomType: "x",
      style: {
        fontFamily: `Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI",
          "Helvetica Neue", Arial, "Noto Sans", sans-serif,
          "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
        height: "100%",
      },
      exporting: {
        enabled: false,
      },
    },
    credits: {
      enabled: false,
    },
    // colors: ["#2F5EC4", "#45a5f5"],
    plotOptions: {
      line: {
        lineWidth: 2,
        states: {
          hover: {
            lineWidth: 3,
          },
        },
        marker: {
          enabled: false,
        },
      },
      spline: {
        lineWidth: 2,
        states: {
          hover: {
            lineWidth: 3,
          },
        },
        marker: {
          enabled: false,
        },
      },
      series: {
        allowPointSelect: true,
        dataLabels: {
          // enabled: true,
          // formatter: function () {
          //   var dataMax = this.series.dataMax;
          //   if (this.y === dataMax) {
          //     return this.y;
          //   }
          // },
        },
        cursor: "pointer",
      },
    },
    time: {
      // useUTC: false,
      // timezone: "Asia/Tehran",
      timezoneOffset: -270,
    },
    yAxis: [
      {
        id: "left1",
        lineWidth: 1,
        title: {
          enabled: false,
        },
      },
      {
        id: "left2",
        title: {
          enabled: false,
        },
      },
      {
        id: "right1",
        lineWidth: 1,
        opposite: true,
        title: {
          enabled: false,
        },
      },
      {
        id: "right2",
        lineWidth: 0,
        opposite: true,
        title: {
          enabled: false,
        },
      },
    ],
    xAxis: [
      {
        id: "bottom1",
        type: "datetime",
        labels: {
          style: { fontWeight: "bold" },
          rotation: 90,
          // format: ""
        },
        lineWidth: 1,

        // plotLines: lines,
        title: {
          enabled: false,
        },
      },
      {
        id: "bottom2",
        type: "datetime",
        labels: {
          style: { fontWeight: "bold" },
          rotation: 90,
          // format: ""
        },
        lineWidth: 1,
        title: {
          enabled: false,
        },
      },
    ],
    tooltip: {
      shared: false,
      crosshairs: true,
    },

    //   legend: {
    //     layout: 'vertical',
    //     align: 'center',
    //     verticalAlign: 'down'
    // },
    series: [],
  };
  const accept = () => {
    data.deleteClick();
  };

  const reject = () => {};
  const confirm = (id) => {
    confirmDialog({
      message: "Do you want to delete this record?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept,
      reject,
    });
  };
  useEffect(() => {
    let isMounted = true;
    let end = new Date();
    let start = new Date();

    const start_mini = strftime("%m-%d", start);
    const end_mini = strftime("%m-%d", end);
    const date_mini = start_mini + "|" + end_mini;

    start.setDate(start.getDate() - parseInt(data.data.range.code));
    for (const chart of data.data.charts) {
      let datax = {
        buket: chart.bucket,
        startDate: start,
        endDate: end,
        scope: chart.scope,
        ne_list: [chart.node],
        kpi_id: chart.kpi,
        tech: chart.tech,
      };
      // setLoading(true);
      performanceManagementService
        .Post("/v2/kpir", datax)
        .then((response) => {
          if (response.data) {
            console.log(response.data);
            for (const chart_data of response.data) {
              if (chart.color) {
                chartRef.current.chart.addSeries({
                  type: chart.type,
                  // id: chart_data.name,
                  visible: true,
                  yAxis: chart.yAxis,
                  xAxis: chart.xAxis,
                  name: chart_data.name,
                  color: chart.color,
                  data: chart_data.data,
                });
              } else {
                chartRef.current.chart.addSeries({
                  type: chart.type,
                  // id: chart_data.name,
                  visible: true,
                  yAxis: chart.yAxis,
                  xAxis: chart.xAxis,
                  name: chart_data.name,
                  data: chart_data.data,
                });
              }
            }
          }
        })
        .catch((e) => {
          // toast.current.show({ severity: 'error', summary: 'Error Message', detail: 'Fech kpi faild' });
          console.log(e);
          // setLoading(false);
        });
    }

    return () => {
      isMounted = false;
    };
  }, []);

  const endContent = (
    <React.Fragment>
      {/* <Button icon="pi pi-search" className="mr-2" />
            <Button icon="pi pi-calendar" className="p-button-success mr-2" /> */}
      <Button
        icon="pi pi-times"
        onClick={confirm}
        rounded
        text
        severity="danger"
        aria-label="Cancel"
      />
    </React.Fragment>
  );
  const startContent = (
    <React.Fragment>{data.data.name + "-" + data.data.user}</React.Fragment>
  );
  const template = (options) => {
    return <Toolbar start={startContent} end={endContent} />;
  };
  return (
    <Panel headerTemplate={template} className="m-1">
      <HighchartsReact
        ref={chartRef}
        highcharts={Highcharts}
        options={options}
        updateArgs={[true, false, true]}
      />
    </Panel>
  );
}
